import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import * as reportes from "../../actions/reports";
import Layout from "../../components/layout";
import PartnerMembershipDirectoryReport from "../../components/partnerMembershipSirectoryReport";
import IAction from "../../../types/IAction";

interface Props {
  downloadReportPartnerMembershipDirectory: (params: any) => IAction;
  userContext: { clubSessionId: any };
}

class PartnerMembershipDirectoryReportPage extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Directorio de membresías socio" />
        <Layout>
          <PartnerMembershipDirectoryReport
            downloadReportPartnerMembershipDirectory={
              this.props.downloadReportPartnerMembershipDirectory
            }
            userContext={this.props.userContext}
          />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    userContext: user.userContext
  };
};

const mapDispatchToProps = dispatch => ({
  downloadReportPartnerMembershipDirectory: params => {
    dispatch(reportes.downloadReportPartnerMembershipDirectory(params));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerMembershipDirectoryReportPage);
